import { DATE_RANGE_LAST_30_DAYS, getDateRangeFromPreset } from 'components/filter/DateRangePresets'

export const MAX_SMS_LENGTH = 160
export const SMS_CREDIT_CONTACT = 'help@civicchamps.com'
export const SMS_CREDIT_PRICE_PER_SMS = 0.02

/** Redux keys for message list date filters (separate from global "this year" default). */
export const CUSTOM_MESSAGES_DATE_RANGE_KEY = 'customMessages'
export const AUTOMATED_MESSAGES_DATE_RANGE_KEY = 'automatedMessages'

export const MESSAGES_LIST_DEFAULT_DATE_RANGE = getDateRangeFromPreset(DATE_RANGE_LAST_30_DAYS)
